import { Fragment } from "react"
import { NavLink } from "react-router-dom"
import { styled } from "@mui/material/styles"
import { connect } from "react-redux"
import { colors } from "../../constants/colors"
const { VITE_APP_EBOL } = import.meta.env

import { Typography, ListItem, ListItemText } from "@mui/material"
import PropTypes from "prop-types"

const StyledNavLink = styled(NavLink)({
    textDecoration: "none",
    display: "flex",
    "& .MuiListItem-button:hover": {
        backgroundColor: colors.GREY2,
    },
    "&.active": {
        backgroundColor: colors.BLUE4,
        "& .MuiListItem-button:hover": {
            backgroundColor: colors.BLUE4,
        },
        "& .MuiTypography-root": {
            color: colors.BLUE2,
            fontWeight: "bold",
        },
    },
})

const NavText = styled(Typography)({
    fontSize: "0.875rem",
    textDecoration: "none",
    color: colors.BLACK,
    opacity: 0.87,
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.71",
    letterSpacing: "normal",
})

export const SideBarSub = (props) => {
    const {
        navItem,
        toggleNavbar,
        showNavbar,
        getEbolToken,
        setEbolRequest,
        ebolWOAccess,
        selectedShipper,
        showEnhancedVisibilityMenu,
    } = props

    let invokeEbol = () => {
        getEbolToken()
        setEbolRequest(1)
    }

    return (
        <Fragment>
            {navItem.id !== "ebol" && navItem.id !== "enhancedVisibility" ? (
                <StyledNavLink exact to={navItem.path} isActive={() => false}>
                    <ListItem
                        button
                        disableTouchRipple
                        key={navItem.id}
                        onClick={() => toggleNavbar(!showNavbar)}
                    >
                        <ListItemText
                            primary={
                                <NavText data-test={navItem.label}>
                                    {navItem.label}
                                </NavText>
                            }
                        />
                    </ListItem>
                </StyledNavLink>
            ) : navItem.id === "ebol" ? (
                <ListItem
                    button
                    disableTouchRipple
                    key={navItem.id}
                    onClick={() => toggleNavbar(!showNavbar)}
                >
                    <ListItemText
                        primary={
                            <NavText
                                data-test={navItem.label}
                                onClick={() => {
                                    if (!ebolWOAccess) {
                                        invokeEbol()
                                    } else {
                                        window.open(
                                            `${VITE_APP_EBOL}/?OAuth=true&ShipperOrgId=${selectedShipper.orgId}`,
                                            "_blank"
                                        )
                                    }
                                }}
                            >
                                {navItem.label}
                            </NavText>
                        }
                    />
                </ListItem>
            ) : (
                <ListItem
                    button
                    disableTouchRipple
                    key={navItem.id}
                    onClick={() => toggleNavbar(!showNavbar)}
                >
                    <ListItemText
                        primary={
                            <NavText
                                data-test={navItem.label}
                                onClick={() => showEnhancedVisibilityMenu()}
                            >
                                {navItem.label}
                            </NavText>
                        }
                    />
                </ListItem>
            )}
        </Fragment>
    )
}
SideBarSub.propTypes = {
    setEbolRequest: PropTypes.func.isRequired,
    getEbolToken: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
    return {
        ebolWOAccess: state.userProfile.ebolWOAccess,
        selectedShipper: state.userProfile.selectedShipper,
    }
}

export default connect(mapStateToProps, null)(SideBarSub)
